export const getFileNameFromUrl = (url?: string): string => url?.split('/').pop()?.split('?')[0] ?? '';
